module.exports = __webpack_public_path__ + "img/national13.89bdff63.png";